var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 參數設定 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 輔翼 會員等級批量調整（逐筆同步） ")])], 1)], 1)])], 1), _c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', [_c('h4', {
    staticClass: "font-weight-bold mb-2"
  }, [_vm._v("輔翼 會員等級批量調整（逐筆同步）")]), _c('p', {
    staticClass: "mb-2 text-muted"
  }, [_vm._v(" 上傳 Excel 後，系統會逐筆同步會員等級到輔翼。 ")])])]), _c('div', {
    staticClass: "import-form"
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "level-file"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-1"
  }, [_c('label', {
    staticClass: "field-label mb-0",
    attrs: {
      "for": "level-file"
    }
  }, [_vm._v("Excel 檔案")])]), _c('b-form-file', {
    attrs: {
      "id": "level-file",
      "accept": ".xlsx,.xls",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽",
      "plain": ""
    },
    model: {
      value: _vm.selectedFile,
      callback: function callback($$v) {
        _vm.selectedFile = $$v;
      },
      expression: "selectedFile"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 格式固定為 4 欄：第 1 欄會員編號、第 2 欄等級代號、第 3 欄會籍開始日、第 4 欄會籍結束日。支援 xlsx / xls，可包含表頭。 ")]), _c('small', {
    staticClass: "form-text text-danger"
  }, [_vm._v(" 請勿填入 內部系統會員編號 或 內部系統會員等級名稱。 ")]), _c('b-button', {
    staticClass: "p-0",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.getSampleExcelFile(null, '/excel/flaps_level_change.xlsx');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text mr-1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 下載範例檔案 ")])], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.handlePreviewSubmit
    }
  }, [_vm.isSubmitting ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _c('i', {
    staticClass: "mdi mdi-sync mr-1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.isSubmitting ? '同步中...' : '開始同步') + " ")], 1)], 1)]), _vm.showResult ? _c('b-card', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3"
  }, [_c('div', [_c('h5', {
    staticClass: "font-weight-bold mb-1"
  }, [_vm._v("同步結果")]), _c('p', {
    staticClass: "mb-0 text-muted"
  }, [_vm._v("以下為同步統計與錯誤列。")])])]), _c('b-row', {
    staticClass: "mb-3"
  }, _vm._l(_vm.summaryItems, function (item) {
    return _c('b-col', {
      key: item.label,
      staticClass: "mb-2",
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('div', {
      class: ['summary-item', "summary-item-".concat(item.variant)]
    }, [_c('div', {
      staticClass: "summary-label"
    }, [_vm._v(_vm._s(item.label))]), _c('div', {
      staticClass: "summary-value"
    }, [_vm._v(_vm._s(item.value))]), _c('div', {
      staticClass: "summary-description"
    }, [_vm._v(_vm._s(item.description))])])]);
  }), 1), _vm.errorRows.length > 0 ? _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.errorRows,
      "fields": _vm.errorFields
    },
    scopedSlots: _vm._u([{
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(data.item.status)
          }
        }, [_vm._v(" " + _vm._s(_vm.getStatusText(data.item.status)) + " ")])];
      }
    }], null, false, 3421781107)
  }) : _c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(" 本次同步沒有錯誤列。 ")])], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }